<template>
    <div class="main-content main-content--wizzard">
        <h1 v-translate>
            Build My Team
        </h1>

        <div class="steps__container">
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-1'}">
                <strong v-translate>Details</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-2'}">
                <strong v-translate>Create teams</strong>
            </div>
        </div>

        <build-my-team-step-one :parent_organization="organization" v-if="stepLocation == 'step-1'" @advance="changeStep"></build-my-team-step-one>

        <build-my-team-step-two :created_organization="created_organization" v-if="stepLocation == 'step-2'"></build-my-team-step-two>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import axios from "axios";
    import BuildMyTeamStepOne from "../components/build-my-team/BuildMyTeamStepOne";
    import BuildMyTeamStepTwo from "../components/build-my-team/BuildMyTeamStepTwo";

    export default {
        name: 'MyTeam-BuildMyTeam',
        components: {BuildMyTeamStepOne, BuildMyTeamStepTwo},
        data() {
            return {
                organization: {
                    name: '',
                    category_business: true,
                    category_health: false,
                    category_relationship: false,
                    category_personal: false,
                    leader: ''
                },
                created_organization: {},
                stepLocation: 'step-1',
            }
        },
        methods: {
            ...mapActions([
                'openPopup'
            ]),
            changeStep: async function (step) {
                let r = (await axios.post('/api/navigator/organizations/', this.organization))
                this.created_organization = r.data;
                this.stepLocation = step;
            },
        }
    }
</script>
